import _ from "lodash";
import React, { useRef } from "react";
import classNames from "classnames";
import classes from "./ImageResizer.scss";

const DIRECTION = {
  NW: "nw",
  NE: "ne",
  SW: "sw",
  SE: "se",
};

/**
 *
 * @param {*} param0
 * @returns Inline editore Image resizer component
 */
const ImageResizer = ({ onResizeEnd, imageRef }) => {
  const positioningRef = useRef({
    ratio: 0,
    startX: 0,
    startY: 0,
    direction: 0,
    startWidth: 0,
    currentWidth: 0,
  });

  // * On image resizing finished
  const handleMouseUp = () => {
    if (imageRef.current) onResizeEnd(imageRef.current.style.width);
    window.removeEventListener("pointerup", handleMouseUp);
    window.removeEventListener("pointermove", handleMouseMove);
  };

  // * Real time updating image and handle on resize
  const handleMouseMove = e => {
    const image = imageRef.current;
    const positioning = positioningRef.current;
    const direction = positioning.direction;

    // * Start width and resize delta change in size
    let width = positioning.startWidth;
    const deltaX = Math.floor(e.clientX - positioning.startX);

    // * Updating delta changes according to direction
    if (direction === DIRECTION.NW || direction === DIRECTION.SW) {
      width -= deltaX;
    } else if (direction === DIRECTION.NE || direction === DIRECTION.SE) {
      width += deltaX;
    }

    // * Minimum scaling sizes, lower to 25px and upper to `100%`(from max-width styling)
    width = Math.max(width, 25);
    image.style.width = `${width}px`;
    positioning.currentWidth = width;
  };

  // * On start, Image resizing
  const handleMouseDown = (event, direction) => {
    event.preventDefault();
    const image = imageRef.current;
    if (!image) return;

    // * Updating ref's initial values
    const { width, height } = image.getBoundingClientRect();
    const positioning = positioningRef.current;
    positioning.startWidth = width;
    positioning.ratio = width / height;
    positioning.currentWidth = width;
    positioning.startX = event.clientX;
    positioning.startY = event.clientY;
    positioning.direction = direction;
    image.style.width = `${width}px`;

    // * listener for resizing
    window.addEventListener("pointerup", handleMouseUp);
    window.addEventListener("pointermove", handleMouseMove);
  };

  return _.map(_.values(DIRECTION), direction => (
    <div
      key={direction}
      onMouseDown={handleMouseDown}
      onPointerDown={event => handleMouseDown(event, direction)}
      className={classNames(classes.imageResizeHandle, {
        [classes.imageResizeHandle_nw]: direction === DIRECTION.NW,
        [classes.imageResizeHandle_ne]: direction === DIRECTION.NE,
        [classes.imageResizeHandle_sw]: direction === DIRECTION.SW,
        [classes.imageResizeHandle_se]: direction === DIRECTION.SE,
      })}
    />
  ));
};

export default ImageResizer;

ImageResizer.defaultProps = {
  imageRef: null,
  onResizeEnd: () => {},
};
